import React from 'react';
import Cookies from 'js-cookie';
import config from '../config.json';
import moment from 'moment';
import { Buffer } from 'buffer';
import axios from 'axios';
import { log } from 'data/logger';
import { toast } from 'react-toastify';
import { Trans } from 'react-i18next';

/**
 * Check if two arrays are equal
 * @param  {Array}   arr1 The first array
 * @param  {Array}   arr2 The second array
 * @return {Boolean}      If true, both arrays are equal
 */
const arraysMatch = function (arr1, arr2) {
	//if either is falsy
	if(!arr1 || !arr2) return false;
	// Check if the arrays are the same length
	if (arr1.length !== arr2.length) return false;

	// Check if all items exist, are in the same order, and are object-equal
	for (var i = 0; i < arr1.length; i++) {
		if(!arr2[i] && arr2[i] !== 0) return false; //falsy but not zero
		if((typeof arr1[i] === 'object') && (arr1[i] instanceof Date)) {
			if(arr1[i].valueOf() !== arr2[i].valueOf()) return false;
		} else if((typeof arr1[i] === 'object') && (arr1[i]._isAMomentObject)) {
			if(!arr1[i].isSame(arr2[i])) return false;
		} else if((typeof arr1[i] === 'object') && (arr1[i] instanceof String)) {
			if(arr1[i].toString() !== arr2[i].toString()) return false;
		} else if(typeof arr1[i] !== 'object') {
			if(arr1[i] !== arr2[i]) return false;
		} else {
			//src is a generic object, call dif()
			var objDiff = diff(arr1[i], arr2[i]); //this handles arrays too
			if (Object.keys(objDiff).length > 0) {
				return false;
			}
		}
	}

	// Otherwise, return true
	return true;

};


export const blobPdfFromBase64String = (base64String) => {
	const byteArray = Uint8Array.from(
		atob(base64String)
			.split('')
			.map(char => char.charCodeAt(0))
	);
	return new Blob([byteArray], { type: 'application/pdf' });
};

export const fetch_reauth = (url, options, n) => {
	if(!n && n!==0) n=1; //always do at least one unless a zero is passed
	Object.assign(options, {
		headers: {
			...options.headers,
			"Authorization": "Bearer " + Cookies.get("x-token")
		}
	});
	return fetch(url, options)
	.then(result => {
		switch(result.status) {
			case 200:
				return result;
			case 428:
				if((options.headers["Authorization"] || options.headers["authorization"]) && n>0) {
					return autologin()
					.then((tok) => {
						delete options.headers["authorization"];
						options.headers["Authorization"] = "Bearer " + tok;
						return fetch_reauth (url, options, n - 1);
					})
					.catch(() => {
						throw Error(result.statusText);
					});
				} else {
					throw Error(result.statusText);
				}
			default:
				throw Error(result.statusText);
		}
	})
};

export const axios_post_reauth = (url, data, options, n) => {
	if(!n && n!==0) n=1; //always do at least one unless a zero is passed
	if (!options.headers) {
		options.headers = {};
	}
	if(!(options.headers["Authorization"] || options.headers["authorization"])) {
		options.headers["Authorization"] = "Bearer " + Cookies.get("x-token");
	}
	options.validateStatus = (status) => {
		return (status >= 200 && status < 300) || status === 428; //428 gets special handling
	};

	return axios.post(url, data, options).then((result) => {
		if (result.status===428) {
			if((options.headers["Authorization"] || options.headers["authorization"]) && n>0) {
				return autologin()
				.then((tok) => {
					delete options.headers["authorization"];
					options.headers["Authorization"] = "Bearer " + tok;
					return axios_post_reauth (url, data, options, n - 1);
				})
				.catch(() => {
					throw Error(result.statusText);
				});
			} else {
				throw Error(result.statusText);
			}
		}
		return true;
	}).catch(err => {
		throw Error(err);
	});
};

export const autologin = async () => {
	let tok = Cookies.get("wtok");
	if (tok) {
		log.trace("auth", "autologin doLoginWilson %s", tok)
		return doLoginWilson(tok)
			.then((sess) => {
				if (sess !== false && sess.token !== '') {
					let expires = (30 * 24) * 60 * 60 * 1000;
					let sessionExpires = new Date(new Date().getTime() + expires)
					Cookies.set('x-token', sess.token, { expires: sessionExpires });
					return sess.token;
				} else {
					return false;
				}
			});
	} else {
		log.trace("auth", "autologin doLogin %s", Cookies.get("token"))
		return doLogin(Cookies.get("token"))
			.then((sess) => {
				if (sess !== false && sess.token !== '') {
					let expires = (parseInt(Cookies.get("remember") || 0) === 1 ? (30 * 24) : 10) * 60 * 60 * 1000;
					let sessionExpires = new Date(new Date().getTime() + expires)
					Cookies.set('x-token', sess.token, { expires: sessionExpires });
					return sess.token;
				} else {
					return false;
				}
			});
	}
};

export const doLogin = async (user) => {
	let auth = false;
	if (typeof user === 'object') {
		auth = Buffer.from(user.username + ":" + user.password).toString('base64');
	} else if (user === '') {
		auth = Cookies.get("token") || '';
	} else {
		auth = user;//it's already a token?
	}

	if (!auth) return false;
	return fetch(util.apihost() + '/auth/', {
		method: 'post',
		headers: {
			'Content-Type':'application/json',
			'Authorization': "Bearer " + Cookies.get('x-token')
		},
		body: JSON.stringify({
			logintoken: auth,
			sesspref: Cookies.get("sesspref") ? JSON.parse(Cookies.get("sesspref")) :  {}
		})
	})
    .then(res => res.json())
    .then(sess => {
		return sess;
	})
	.catch((reason) => {
		log.error("auth", "error %O", reason);
		return false;
	});
};

export const doLoginWilson = async (apikey) => {
	return fetch(util.apihost() + '/auth/wilson', {
		method: 'post',
		headers: {'Content-Type':'application/json'},
		body: JSON.stringify({
			logintoken: apikey,
			sesspref: Cookies.get("sesspref") ? JSON.parse(Cookies.get("sesspref")) :  {}
		})
	})
    .then(res => res.json())
    .then(sess => {
		return sess;
	})
	.catch((reason) => {
		log.trace("auth", "wilson auth error", reason);
		return false;
	});
};

/*!
 * Find the differences between two objects and push to a new object
 * (c) 2019 Chris Ferdinandi & Jascha Brinkmann, MIT License, https://gomakethings.com & https://twitter.com/jaschaio
 * @param  {Object} obj1 The original object
 * @param  {Object} obj2 The object to compare against it
 * @return {Object}      An object of differences between the two
 */
const diff = (obj1, obj2) => {

    // Make sure an object to compare is provided
    if (!obj2 || Object.prototype.toString.call(obj2) !== '[object Object]') {
        return obj1;
    }

    //
    // Variables
    //

    var diffs = {};
    var key;


    //
    // Methods
    //

    /**
     * Compare two items and push non-matches to object
     * @param  {*}      item1 The first item
     * @param  {*}      item2 The second item
     * @param  {String} key   The key in our object
     */
    var compare = function (item1, item2, key) {

        // Get the object type
        var type1 = Object.prototype.toString.call(item1);
        var type2 = Object.prototype.toString.call(item2);

		// If type2 is undefined it has been removed
        if (type2 === '[object Undefined]') {
            diffs[key] = null;
            return;
        }

        // If items are different types
        if (type1 !== type2) {
            diffs[key] = item2;
            return;
        }

        // If an object, compare recursively
        if (type1 === '[object Object]') {
            var objDiff = diff(item1, item2);
            if (Object.keys(objDiff).length > 0) {
                diffs[key] = objDiff;
            }
            return;
        }

        // If an array, compare
        if (type1 === '[object Array]') {
            if (!arraysMatch(item1, item2)) {
				diffs[key] = item2;
            }
            return;
        }

		//type specific tests
		if((typeof item1 === 'object') && (item1 instanceof Date)) {
			if(item1.valueOf() !== item2.valueOf()) diffs[key] = item2;
		} else if((typeof item1 === 'object') && item1!==null && item1!==undefined && (item1._isAMomentObject)) {
			if(!item1.isSame(item2)) diffs[key] = item2;
		} else if((typeof item1 === 'object') && (item1 instanceof String)) {
			if(item1.toString() !== item2.toString()) diffs[key] = item2;
		} else if(typeof item1 !== 'object') {
			if(item1 !== item2) diffs[key] = item2;
		} else if (type1 === '[object Function]') {
			// Else if it's a function, convert to a string and compare
			if (item1.toString() !== item2.toString()) {
                diffs[key] = item2;
            }
        } else {
			// Otherwise, just compare
			//console.log("diff compare other", key, item1, item2)
            if (item1 !== item2 ) {
                diffs[key] = item2;
            }
        }

    };


    //
    // Compare our objects
    //

    // Loop through the first object
    for (key in obj1) {
        if (Object.prototype.hasOwnProperty.call(obj1, key)) {
            compare(obj1[key], obj2[key], key);
        }
    }

    // Loop through the second object and find missing items, consider null to not exist
    for (key in obj2) {
        if (Object.prototype.hasOwnProperty.call(obj2, key)) {
			if (!obj1[key] && obj1[key] !== obj2[key] && Object.prototype.toString.call(obj2[key]) !== "[object Null]") {
                diffs[key] = obj2[key];
            }
        }
    }

    // Return the object of differences
    return diffs;

};

export const util = {
	PI: 3.14159, //use only this for PI
	currency: (val, cur, replace_zero = false) => { //pass replace_zero as a translated string to replace zeros
		if(val === '' || cur === '' || isNaN(parseFloat(val))) return '';
		if(replace_zero && !val) return replace_zero;
		return '$' + parseFloat(val).toFixed(2) + ' ' + cur;
	},
	percent: (val, places) => {
		if(val === '' || isNaN(parseFloat(val))) val = 0;
		val = val*100.0;
		if(Math.round(val, places) === parseInt(val)) return parseInt(val) + '%';
		return parseFloat(val).toFixed(places) + '%';
	},
	default: (item, value) => {
		if(item === undefined) return value;
		if(typeof(item) == "string") return item.trim();
		return item;
	},
	test: (item, value) => {
		if(item === undefined) return false;
		if(typeof(item) == "string") item = item.trim();
		return item === value;
	},
	plainDate: (date) => { //date should be a Date object
		if(!date || !date.getFullYear) return "";
		return (
			date.getFullYear() + "-" + 
			(date.getMonth()<9 ? "0"+(date.getMonth()+1) : (date.getMonth()+1)) + "-" + 
			(date.getDate()<10 ? "0"+date.getDate() : date.getDate())
		);
	},
	htmlEntities: (str) => {
		return String(str).replace(/</g, '&lt;').replace(/>/g, '&gt;');
	},
	timer: (handler, delay) => {
		const timeID = setTimeout(handler, delay);
		return {
			clear: () => clearTimeout(timeID),
			trigger: () => {
				clearTimeout(timeID);
				return handler();
			}
		}
	},
	indexOfObject: (arr, item) => {
		let keys=Object.keys(item);
		
		for(let i=0; i<arr.length; i++) {
			let matches=0;
			for(let k=0; k<keys.length; k++) {
				if(item[keys[k]] === arr[i][keys[k]]) {
					matches++;
				}
			}

			if(matches === keys.length) {
				return i;
			}
		}
		return -1;
	},
	clone: (obj) => {
		return pureRecursiveMerge(obj, {});
	},
	arraysMatch: arraysMatch,
	objectDiff: diff,
	pushUnique: (arr, item, keys, update=false) => {
		let matchIndex = arr.findIndex(r => {
			let i = keys.filter(k => {
				return r[k] === item[k]
			});
			return i.length === keys.length
		});

		if(matchIndex === -1) {
			arr.push(item);
		} else if(update) {
			arr[matchIndex] = item;
			//odd place to put this, this seems cleanest for now.
			if(item.type && item.notice && item.expires) { //this will trigger restarting the animation on notices with expire times
				let el = document.getElementById("wrn" + matchIndex);
				el.style.animation = "none";
				/* eslint-disable no-unused-vars */
				let x = el.offsetHeight; //don't need the value, just need to trigger reflow
				el.style.animation = null;
			}
			
		} 
		return arr;
	},
	indexByKeys: (arr, item, keys) => {
		let matchIndex = -1;
		for(let i=0; i<arr.length; i++) {
			let matches=0;
			for(let k=0; k<keys.length; k++) {
				if(item[keys[k]] === arr[i][keys[k]]) {
					matches++;
				}
			}
			if(matches === keys.length) { //full match, record it and bail
				matchIndex = i;
				break;
			}
		}
		return matchIndex;
	},
	measure: (value, units, places=4, label=true) => {
		if(value === '' || isNaN(parseFloat(value))) return '';
		let lab = '';
		switch(units)
		{
			case 'met':
				places = places-1;
				value = parseFloat(value) * 25.4;
				if(label) lab = 'mm';
				break;
			case 'si':
				if(label) lab = '"';
				break;
			default: break;
		}
		if(places<0) places=0;
		return util.round(value, places).toFixed(places) + lab;
	},
	round: (value, places) => {
		let m = parseInt("1" + "0".repeat(places)); //trick to round correctly
		return Math.round(parseFloat(value)*m)/m;
	},
	floor: (value, places) => {
		let m = parseInt("1" + "0".repeat(places)); //trick to round correctly
		return Math.floor(parseFloat(value)*m)/m;
	},
	//updates the rule reference with a unit switch if it's a floatrange or minorzero
	//returns true if an update was made.
	switchRuleUnits: ({rule, units}) => {
		let didUpdate = false;
		if(typeof rule === "string") {
			if((rule.startsWith("floatrange") || rule.startsWith("minorzero")) && rule.indexOf(units) === false) {
				rule = rule.replace((units==="si"?"mm":"si"), units);
				didUpdate = true;
			}
		} else if(Array.isArray(rule)) {
			rule.forEach(r => {
				if((r.startsWith("floatrange") || r.startsWith("minorzero")) && r.indexOf(units) === false) {
					r = r.replace((units==="si"?"mm":"si"), units);
					didUpdate = true;
				}
			});
		}
		return didUpdate;
	},
	toDisp: (value, units) => {
		if (value === '') return '';
		//if pref is in mm, convert inch $value to mm
		
		switch(units)
		{
			case 'met':
				value = parseFloat(value) * 25.4;
				break;
			default: break;
		}
		return value;
	},
	toStore: (value, units) => {
		if (value === '') return '';
		//if pref is in mm, convert mm $value to inch
		switch(units)
		{
			case 'met':
				value = parseFloat(value) / 25.4;
				break;
			default: break;
		}
		return value;
	},
	EllipseCirc: (a,b) => {
		//per Ryan
		//return 2.0 * Math.PI * Math.sqrt(((a*a)+(b*b))/2);
		// per google
		let x = Math.max(a,b);
		let y = Math.min(a, b);
		let digits = 53; 
		let tol = Math.sqrt(Math.pow(0.5, digits));

		if (digits * y < tol * x) return 4 * x;
		let s = 0, m = 1;
		while (x - y > tol * y) {
			x = Math.sqrt(x * y);
			y = 0.5 * (x + y);
			m *= 2; 
			s += m * Math.pow(x - y, 2);
		}
		return Math.PI * (Math.pow(a + b, 2) - s) / (x + y); 
	},
	PDfromCirc: (circ) => {
		return parseFloat(circ)/util.PI;
	},
	CircFromPd: (pd) => {
		if(!pd) return 0;
		return util.PI * pd;
	},
	PDFromTeeth: (Teeth, Pitch) => {
		var sPitch = String(Pitch);
		var nTeeth = parseInt(Teeth);
		
		sPitch = sPitch.toString();
			
		var dPD = "";
		var nNum1, nNum2;
		if (sPitch.substring(0, 3) === "MOD")
		{
			nNum1 = parseFloat(sPitch.substring(3, sPitch.length));
			dPD = (nTeeth / (25.4 / nNum1))
		}
		else
		{
			var sType = sPitch.substring(sPitch.length-2,sPitch.length);
					
			if (sType === "CP")
			{
				if (sPitch.substring(sPitch.length-4,sPitch.length-2) === "mm")
				{
					nNum1 = sPitch.substring(0,sPitch.indexOf("mm"));
					dPD = nTeeth / (util.PI / (parseFloat(nNum1) / 25.4)); //convert mm to in
				}
				else
				{
					nNum1 = sPitch.substring(0,sPitch.indexOf("/"));
					nNum2 = sPitch.substring(sPitch.indexOf("/")+1, sPitch.length-2);
								
					dPD = (nTeeth * (parseFloat(nNum1) / parseFloat(nNum2)) / util.PI);
				}
			}
			
			if (sType === "DP")
			{
				nNum1 = sPitch.substring(0,sPitch.length-2);
							
				dPD = (nTeeth / parseFloat(nNum1));
			}
		}
	
		return dPD;
	},
	CircFromTeeth: (Teeth, Pitch) => {
		var sPitch = String(Pitch);
		var nTeeth = parseInt(Teeth);
		
		sPitch = sPitch.toString();
		
		var dCircumference = "";
		var nNum1, nNum2;
		if (sPitch.substring(0, 3) === "MOD")
		{
			nNum1 = sPitch.substring(3, sPitch.length);
			dCircumference = (nTeeth / (25.4 / nNum1)) * util.PI;
		}
		else
		{
			var sType = sPitch.substring(sPitch.length-2,sPitch.length);
					
			if (sType === "CP")
			{
				if (sPitch.substring(sPitch.length-4,sPitch.length-2) === "mm")
				{
					nNum1 = sPitch.substring(0,sPitch.indexOf("mm"));
					dCircumference = nTeeth * (parseFloat(nNum1) / 25.4); //convert mm to in
				}
				else
				{
					nNum1 = sPitch.substring(0,sPitch.indexOf("/"));
					nNum2 = sPitch.substring(sPitch.indexOf("/")+1, sPitch.length-2);
								
					dCircumference = nTeeth * (parseFloat(nNum1) / parseFloat(nNum2));
				}
			}
			
			if (sType === "DP")
			{
				nNum1 = sPitch.substring(0,sPitch.length-2);
							
				dCircumference = (nTeeth / parseFloat(nNum1)) * util.PI;
			}
		}
		return dCircumference;
	},
	TeethFromPD: (pd, pitch) => {
		var sPitch = String(pitch);
		var nPD = parseFloat(pd);
		
		sPitch = sPitch.toString();
		
		var nTeeth = "";
		var nNum1, nNum2;
		
		if (sPitch === "N/A")
		{
			return 0;
		}
	
		nPD = util.toStore(nPD); //formula only work on inches?
		
		if (sPitch.substring(0, 3) === "MOD")
		{
			nNum1 = sPitch.substring(3, sPitch.length);
			nTeeth = Math.round((25.4 / parseFloat(nNum1)) * nPD);
		}
		else
		{
			var sType = sPitch.substring(sPitch.length-2,sPitch.length);
					
			if (sType === "CP")
			{
				if (sPitch.substring(sPitch.length-4,sPitch.length-2) === "mm")
				{
					nNum1 = sPitch.substring(0,sPitch.indexOf("mm"));
					nTeeth = Math.round(nPD * (util.PI / (parseFloat(nNum1) / 25.4))); //convert mm to in
				}
				else
				{
					nNum1 = sPitch.substring(0,sPitch.indexOf("/"));
					nNum2 = sPitch.substring(sPitch.indexOf("/")+1, sPitch.length-2);
								
					nTeeth = Math.round(nPD * (util.PI / (parseFloat(nNum1) / parseFloat(nNum2))));
				}
			}
			
			if (sType === "DP")
			{
				nNum1 = sPitch.substring(0,sPitch.length-2);
							
				nTeeth = Math.round(parseFloat(nNum1) * nPD);
			}
		}
		return nTeeth;
	},
	TeethFromCirc: (circ, pitch) => {
		var sPitch = String(pitch);
		var nCirc = parseFloat(circ);
		
		sPitch = sPitch.toString();
		
		var nTeeth = "";
		var nNum1, nNum2;
		
		if (sPitch === "N/A")
		{
			return 0;
		}
	
		nCirc = util.toStore(nCirc); //formula only work on inches?
		
		if (sPitch.substring(0, 3) === "MOD")
		{
			nNum1 = sPitch.substring(3, sPitch.length);
			
			nTeeth = Math.round((nCirc / util.PI) * ((25.4 / nNum1)));
		}
		else
		{
			var sType = sPitch.substring(sPitch.length-2,sPitch.length);
					
			if (sType === "CP")
			{
				if (sPitch.substring(sPitch.length-4,sPitch.length-2) === "mm")
				{
					nNum1 = sPitch.substring(0,sPitch.indexOf("mm"));
					
					nTeeth = Math.round(nCirc / (parseFloat(nNum1) / 25.4)); //convert mm to in
				}
				else
				{
					nNum1 = sPitch.substring(0,sPitch.indexOf("/"));
					nNum2 = sPitch.substring(sPitch.indexOf("/")+1, sPitch.length-2);
								
					nTeeth = Math.round(nCirc / (parseFloat(nNum1) / parseFloat(nNum2)));
				}
			}
			
			if (sType === "DP")
			{
				nNum1 = sPitch.substring(0,sPitch.length-2);
							
				nTeeth = Math.round((nCirc / util.PI) * parseFloat(nNum1));
			}
		}
		return nTeeth;
	},
	shapedata: (q) => {
		return {
			shape_code: q.shape_code,
			size_across: parseFloat(q.size_across),
			number_across: parseFloat(q.number_across),
			space_between_across: parseFloat(q.space_between_across),
			offset_towards_gear: parseFloat(q.offset_towards_gear),

			size_around: parseFloat(q.size_around),
			number_around: parseFloat(q.number_around),
			space_between_around: parseFloat(q.space_between_around),
			
			center_to_center_around: parseFloat(q.center_to_center_around),
			corner_radius: parseFloat(q.corner_radius),

			pd: parseFloat(q.pd),
			circumference: parseFloat(q.circumference),
			undercut: parseFloat(q.undercut)
		}
	},
	humanFileSize: (bytes, decimals = 2) => {
		var thresh = 1024;
		if(Math.abs(bytes) < thresh) {
			return bytes + ' B';
		}
		var units = ['KB','MB','GB','TB','PB','EB','ZB','YB'];
		var u = -1;
		do {
			bytes /= thresh;
			++u;
		} while(Math.abs(bytes) >= thresh && u < units.length - 1);
		return bytes.toFixed(decimals)+' '+units[u];
	},
	buildProdDetail: (t, units, row) => {
		let titleLine = t("prod_" + row.prod_code);
		if(row.press_description) { //don't display a press if it doesn't have one (MP,FM, maybe gear)
			titleLine += " - " + row.press_description + " (" + row.roll_drawing_number + ")";
		}
		let prodLine1 = "";
		let prodLine2 = "";
		switch (row.prod_code) {
			case "DLR":
			case "ED":
			case "FCS":
				prodLine1 = t("shape_" + row.shape_code) + ": ";
				switch(row.shape_code) {
					case "EGL":
						prodLine1 += row.number_across + " X " + util.measure(row.inches_across, units);
						break;
					case "CSC":
						prodLine1 += row.number_around + " X " + util.measure(row.inches_around, units);
						break;
					default:
						prodLine1 += util.measure(row.inches_across, units) + " X " + util.measure(row.inches_around, units);
						break;
				}
				if((row.prod_code === "FCS" || row.prod_code === "DLR") && row.rotary) {
					prodLine1 += " (" + t("fcstype"+row.rotary) + ")"
				}
				break;
			default:
				prodLine1 = row.pitch || "";
		}
		if(row.po) {
			prodLine1 += " " + t("lbl_po") + ": " + row.po
		}
		if(row.entered_by) {
			prodLine1 += " " + t("lbl_quotedby") + ": " + row.entered_by;
		}
		if(row.customer_die_number) {
			prodLine2 += " " + t("lbl_custdienum") + ": " + row.customer_die_number
		}
		if(row.comment) {
			prodLine2 += " Comment: " + row.comment
		}
		return {titleLine, prodLine1, prodLine2, detail:titleLine+prodLine1+prodLine2};
	},
	formatOrderStatus: (t, units, row) => {
		let prod = util.buildProdDetail(t, units, row);
		let barcss = {};
		let status = t('stat_released');
		let statusadd = [];
		let ship_desc = row.ship_description  + (row.ship_sat === 0 ? '' : ' - SAT');
		if(row.not_shipped) { //full override
			status = t('stat_' + row.not_shipped);
		} else if(row.shipped === 1) {
			if(row.cancelled !== 0) {
				status = t('stat_canceled');
			} else if(row.scrapped !== 0) {
				status = t('stat_scrapped');
			} else {
				status = t('lbl_shipped');
			}
		} else { //not shipped, figure out progress and status
			if(row.prod_code === 'DLR') {
				if(row.shipped === 2) {
					status = t('stat_pendappr');
				} else {
					status = t("stat_inprod");
				}
			} else if(row.progress) {
				status = t("stat_"+row.progress);
			}
			if(row.wfm !== 0) {
				statusadd.push(t('stat_waitingmtl'));
				barcss.backgroundColor = "#FF9800";
			}
			if(row.customer_hold !== 0) {
				statusadd.push(t('stat_customerhold'));
				barcss.backgroundColor = "orangered";
			}
		}
		if(statusadd.length > 0) {
			status += " ( " + statusadd.join(", ") + " )";
		}
		
		return {...prod, ship_description:row.ship_description, prod_status:status, ship_desc, status_detail:status+ship_desc, barcss};
	},
	doOrderDiscount: ({order_disc, prod_code, customer_number, orderData}) => {
		//console.log({order_disc, prod_code, customer_number})
		let disc = order_disc.find(d=> 
			d.prod_code===prod_code && 
			d.customer_number===customer_number &&
			moment().isBetween(d.date_start.substring(0, 10), d.date_end.substring(0, 10), "day", "[]")
		);
		//console.log("disc", disc)
		if(!disc || disc.multiplier===1) {
			orderData.discount_note = false;
		} else if(disc.multiplier) {
			orderData.discount_note = {
				invoice_amount:Math.ceil(orderData.invoice_amount * disc.multiplier), 
				phrase:"lbl_onlinediscount", 
				vars:{
					var1:(100-(disc.multiplier*100)) + "%",
					var2: util.currency(Math.ceil(orderData.invoice_amount * disc.multiplier), orderData.invoice_currency),
				},
			};
		} else {
			orderData.discount_note = false;
		}
		//console.log(orderData.discount_note)
	},
	perOrderDiscount: ({customer, prod_code, shape_code}) => {
		let disc = 0;
		if(customer.disc_per_ord !== undefined) { //session cache issue
			let disc_per_ord = customer.disc_per_ord.find(d => d.prod_code === prod_code);
			if(disc_per_ord !== null && disc_per_ord !== undefined) {
				disc = disc_per_ord.discount;
				if(disc_per_ord.shape && disc_per_ord.shape.SS && shape_code && shape_code === "SS") {
					disc += disc_per_ord.shape.SS;
				}
			}
		}
		return disc;
	},
	perOrderDiscountDisplay: ({t, customer, prod_code, shape_code}) => {
		let disc = util.perOrderDiscount({customer, prod_code, shape_code});
		if(disc === 0) {
			return [];
		} else {
			return [
				{ title: t("lbl_invoicediscount"), value: util.percent(disc, 2) },
			];
		}
	},
	isdevsystem: () => {
		if(window.location.host === "dev.mywilsonmfg.com") {
			return true; //this is dev, but other mywilsonmfg.com are considered prod
		} else if(window.location.host.indexOf("mywilsonmfg.com") >= 0) {
			return false;
		} else { //anything else is dev
			return true
		}
	},
	apihost: () => {
		if(window.location.host === "dev.mywilsonmfg.com") {
			return config.apihost.replace("{devprod}", "dev"); //dev. is server dev
		} else if(window.location.host.indexOf("mywilsonmfg.com") >= 0) {
			return config.apihost.replace("{devprod}", ""); //any other mywilsonmfg is prod
		} else { //anything else is same host, ignoring port, and add dev port (4001)
			return "http://" + window.location.host.split(":")[0] + ":4001";
		}
	},
	toastUnique: (data, toasts, level, title, opts) => {
		if(!level) level = toast.TYPE.ERROR;
		if(!title) title = "";
		if(!toasts) toasts = {current:[]};
		if(!opts) opts = {};
		let errlist = [];
		if(typeof data === 'object') {
			errlist = Object.keys(data).map(k=> {
				return "<li>" +k + ": " + data[k] + "</li>";
			});
		} else {
			errlist.push(data);
		}
		let tmsg = errlist.join('');
		if(toasts.current[tmsg]) {
			toast.update(toasts.current[tmsg], {
				type: level, 
				render:<Trans><b>{title}</b><ul>{tmsg}</ul></Trans>,
				...opts
			});
		} else {
			toasts.current[tmsg] = toast(<Trans><b>{title}</b><ul>{tmsg}</ul></Trans>, {type:level, onClose:()=>{ 
				delete toasts.current[tmsg]; 
			}, ...opts});
		}
	},
};

export const renderFcsBrand = ({ t, row }) => {
	return (
		<div>
			<div style={{fontWeight:"bold"}}>{row.text}</div>
			<div style={{fontSize:"12px"}}>{t("fcsbranddesc_"+row.value)}</div>
		</div>
	);
}

export const renderRBTBladeType = ({ t, row }) => {
	return (
		<div>
			<div style={{fontWeight:"bold"}}>{row.text}</div>
			<div style={{fontSize:"12px"}}>{t("rbt_blade"+row.value + "desc")}</div>
		</div>
	);
}

// Returns the merged object without changing either input object.  
// Shares as much structure with src and dest as possible
export const pureRecursiveMerge = (src, dest, debug=false) => {
	debug && console.log("pureRecursiveMerge start", debug, typeof src);
	if(Array.isArray(src)) { //got an array
		debug && console.log("pureRecursiveMerge array src", JSON.stringify(src))
		let rv = []; //always overwrite arrays
		//loop and recurse objects just in case they are references
		src.forEach((s, index) => {
			//recurse as though it's an object, if it isn't the recursion will fix it, and deep clone the object
			rv[index] = pureRecursiveMerge(s, {}, debug);
		});
		debug && console.log("pureRecursiveMerge end array", JSON.stringify(rv))
		return rv;
	} else if((typeof src === 'object') && (src instanceof Date)) {
		debug && console.log("pureRecursiveMerge end date", src)
		return new Date(src.valueOf()); //clone date 
	} else if((typeof src === 'object') && (src._isAMomentObject)) {
		debug && console.log("pureRecursiveMerge end Moment", src)
		return src.clone(); //clone Moment
	} else if((typeof src === 'object') && (src instanceof String)) {
		debug && console.log("pureRecursiveMerge end special", src)
		return src.toString(); //clone String object to basic string
	} else if(typeof src !== 'object') {
		debug && console.log("pureRecursiveMerge end primitive", JSON.stringify(src))
		return src; //primitive value? just return it
	} else {
		//src is a generic object, parse its keys, unless it's flagged to reset
		if (src._fullreset) {
			delete src._fullreset;
			return src;
		}
		const keys = Object.keys(src).filter(k => src[k] !== null && src[k] !== undefined);
		debug && console.log("pureRecursiveMerge keys", JSON.stringify(keys))
		if (keys.length === 0) {
			debug && console.log("pureRecursiveMerge end nokeys", JSON.stringify(src))
			return dest; //nothing to change
		}
		let rv = { ...dest };
		keys.forEach(k => {
			const v = rv[k];
			debug && console.log("pureRecursiveMerge v", typeof v, JSON.stringify({k, v, s: src[k]}))
			//dest key exists and is an object type
			if (v !== null && (typeof v === 'object') ) {
				rv[k] = pureRecursiveMerge(src[k], v, debug);
			} else { //recurse as though it's an object, if it isn't the recursion will fix it
				rv[k] = pureRecursiveMerge(src[k], {}, debug);
			}
		});
		debug && console.log("pureRecursiveMerge end", JSON.stringify(rv))
		return rv;
	}
};

/* item is expected in this format:
	{
		name: "field_name"
		state: Object
	}
	Object can be any valid javascript primitive value, array, or object.  
	Objects get merged, all others replaced.
*/
export const editStateReducer = (editState, item) => {
	let newState = { ...editState };
	if(!Array.isArray(item)) { //make single updates an array
		item = [item];
	}
	item.forEach(i => {
		//item is object, exists in current as object, merge it
		if (typeof (i.state) === "object") {
			if(newState[i.name] && typeof (newState[i.name]) === "object") {
				newState[i.name] = pureRecursiveMerge(i.state, newState[i.name]);
			} else {
				newState[i.name] = { ...i.state };
			}
		} else{
			newState[i.name] = i.state;
		}
	});
	//console.log("editStateReducer", JSON.stringify({item, editState, newState}))
	return newState;
}

//removes fields that are numbers that evaluated to NaN and/or left a string "NaN"
export const removeAllNaN = (items) => {
	let didChange = false;
	Object.keys(items).forEach(k => {
		if (k.substring(0, 1) === "_") {
			//ignore special keys
		} else if (items[k] === null) {
			//keep it?
		} else if (typeof (items[k]) === "object") {
			if (removeAllNaN(items[k])) didChange = true;
		} else if (items[k] === "NaN" || (typeof (items[k]) === "number" && isNaN(items[k]))) {
			delete items[k];
			didChange = true;
		}
	});
	return didChange;
}

